import { Action } from 'redux';
import { ListGroupedByBundleOut, SelectionListCommentOut, SelectionListOut, SpocContextChangeResponse } from '../api';
import { OrderListActionUpdateName, OrderListActionVisibility } from './actions';
import { ErrorAction } from '../index';
import { Orderlist } from '../../../models/OrderList';

export const CREATE_SELECTIONLIST = 'CREATE_SELECTIONLIST';
export type CreateSelectionlistAction = {
    type: typeof CREATE_SELECTIONLIST;
    payload: SelectionListOut;
};

export const DELETE_SELECTIONLIST = 'DELETE_SELECTIONLIST';
export type DeleteSelectionlistAction = {
    type: typeof DELETE_SELECTIONLIST;
    payload: string;
};

export const CHANGE_ACTIVE_SELECTIONLIST = 'CHANGE_ACTIVE_SELECTIONLIST';
export type ChangeActiveSelectionlistAction = {
    type: typeof CHANGE_ACTIVE_SELECTIONLIST;
    payload?: string;
};

export const SET_ACTIVE_LIST = 'SET_ACTIVE_LIST';
export type SetActiveListAction = {
    type: typeof SET_ACTIVE_LIST;
    payload: SelectionListOut;
};

export const SELECTIONLISTS_REQUEST = 'SELECTIONLISTS_REQUEST';
export type SelectionlistsRequestAction = Action<typeof SELECTIONLISTS_REQUEST>;

export const SELECTIONLISTS_SUCCESS = 'SELECTIONLISTS_SUCCESS';
export type SelectionlistsSuccessAction = {
    type: typeof SELECTIONLISTS_SUCCESS;
    payload: Array<SelectionListOut>;
};

export const SELECTIONLISTS_FAILURE = 'SELECTIONLISTS_FAILURE';
export type SelectionlistsFailureAction = {
    type: typeof SELECTIONLISTS_FAILURE;
    error: boolean;
    payload: Array<Orderlist>;
};

export const SELECTIONLISTS_UPDATE_NAME = 'SELECTIONLISTS_UPDATE_NAME';
export type SelectionlistsUpdateNameAction = {
    type: typeof SELECTIONLISTS_UPDATE_NAME;
    payload: OrderListActionUpdateName;
};

export const SET_LIST_SHARED_STATE = 'SET_LIST_SHARED_STATE';
export type ChangeSharedStateAction = {
    type: typeof SET_LIST_SHARED_STATE;
    payload: boolean;
};

export const ADD_TO_LIST = 'ADD_TO_LIST';
export type AddToListAction = Action<typeof ADD_TO_LIST>;

export const ADD_TO_LIST_BULK = 'ADD_TO_LIST_BULK';

export const MOVE_TO_LIST = 'MOVE_TO_LIST';

export const COPY_TO_LIST = 'COPY_TO_LIST';

export const REMOVE_FROM_LIST = 'REMOVE_FROM_LIST';

export const SELECTIONLIST_SUMMARY_SUCCESS = 'SELECTIONLIST_SUMMARY_SUCCESS';
export type SelectionlistSummarySuccessAction = {
    type: typeof SELECTIONLIST_SUMMARY_SUCCESS;
    payload: SelectionListOut;
};

export const SELECTIONLIST_SUMMARY_FAILURE = 'SELECTIONLIST_SUMMARY_FAILURE';
export type SelectionlistSummaryFailureAction = ErrorAction<typeof SELECTIONLIST_SUMMARY_FAILURE>;

export const SELECTIONLIST_GROUPED_REQUEST = 'SELECTIONLIST_GROUPED_REQUEST';
export type SelectionlistGroupedRequestAction = Action<typeof SELECTIONLIST_GROUPED_REQUEST>;

export const SELECTIONLIST_GROUPED_SUCCESS = 'SELECTIONLIST_GROUPED_SUCCESS';
export type SelectionlistGroupedSuccessAction = {
    type: typeof SELECTIONLIST_GROUPED_SUCCESS;
    payload: Array<ListGroupedByBundleOut>;
};

export const SELECTIONLIST_GROUPED_FAILURE = 'SELECTIONLIST_GROUPED_FAILURE';
export type SelectionlistGroupedFailureAction = Action<typeof SELECTIONLIST_GROUPED_FAILURE>;

export const SELECTIONLIST_GROUPED_CHANGE_REQUEST = 'SELECTIONLIST_GROUPED_CHANGE_REQUEST';
export type SelectionlistGroupedChangeRequestAction = Action<typeof SELECTIONLIST_GROUPED_CHANGE_REQUEST>;

export const SELECTIONLIST_GROUPED_CHANGE_SUCCESS = 'SELECTIONLIST_GROUPED_CHANGE_SUCCESS';
export type SelectionlistGroupedChangeSuccessAction = Action<typeof SELECTIONLIST_GROUPED_CHANGE_SUCCESS>;

export const SELECTIONLIST_GROUPED_CHANGE_FAILURE = 'SELECTIONLIST_GROUPED_CHANGE_FAILURE';
export type SelectionlistGroupedChangeFailureAction = Action<typeof SELECTIONLIST_GROUPED_CHANGE_FAILURE>;

export const SELECTIONLIST_GROUPED_MOVE_REQUEST = 'SELECTIONLIST_GROUPED_MOVE_REQUEST';
export type SelectionlistGroupedMoveRequestAction = Action<typeof SELECTIONLIST_GROUPED_MOVE_REQUEST>;

export const SELECTIONLIST_GROUPED_MOVE_SUCCESS = 'SELECTIONLIST_GROUPED_MOVE_SUCCESS';
export type SelectionlistGroupedMoveSuccessAction = Action<typeof SELECTIONLIST_GROUPED_MOVE_SUCCESS>;

export const SELECTIONLIST_GROUPED_MOVE_FAILURE = 'SELECTIONLIST_GROUPED_MOVE_FAILURE';
export type SelectionlistGroupedMoveFailureAction = Action<typeof SELECTIONLIST_GROUPED_MOVE_FAILURE>;

export const SELECTIONLIST_DELETE_CONFIRMATION = 'SELECTIONLIST_DELETE_CONFIRMATION';
export type SelectionlistDeleteConfirmationAction = {
    type: typeof SELECTIONLIST_DELETE_CONFIRMATION;
    payload: number;
};

export const SELECTIONLIST_EDIT_REQUEST = 'SELECTIONLIST_EDIT_REQUEST';
export type SelectionlistEditRequestAction = Action<typeof SELECTIONLIST_EDIT_REQUEST>;

export const SELECTIONLIST_EDIT_CONFIRMATION = 'SELECTIONLIST_EDIT_CONFIRMATION';
export type SelectionlistEditConfirmationAction = {
    type: typeof SELECTIONLIST_EDIT_CONFIRMATION;
    payload: SelectionListCommentOut;
};

export const SELECTIONLIST_EDIT_ABORT_EMPTY_TEXT = 'SELECTIONLIST_EDIT_ABORT_EMPTY_TEXT';
export type SelectionlistEditAbortEmptyTextAction = Action<typeof SELECTIONLIST_EDIT_ABORT_EMPTY_TEXT>;

export const SELECTIONLIST_VISIBILITY = 'SELECTIONLIST_VISIBILITY';
export type SelectionlistVisibilityAction = {
    type: typeof SELECTIONLIST_VISIBILITY;
    payload: OrderListActionVisibility;
};

export const SELECTIONLIST_TOGGLE_SELECTIONBAR = 'SELECTIONLIST_TOGGLE_SELECTIONBAR';
export type SelectionlistToggleSelectionbarAction = Action<typeof SELECTIONLIST_TOGGLE_SELECTIONBAR>;

export const SELECTIONLIST_SEND_FOR_APPROVAL_REQUEST = 'SELECTIONLIST_SEND_FOR_APPROVAL_REQUEST';
export type SelectionlistSendForApprovalRequestAction = Action<typeof SELECTIONLIST_SEND_FOR_APPROVAL_REQUEST>;

export const SELECTIONLIST_SEND_FOR_APPROVAL_SUCCESS = 'SELECTIONLIST_SEND_FOR_APPROVAL_SUCCESS';
export type SelectionlistSendForApprovalSuccessAction = Action<typeof SELECTIONLIST_SEND_FOR_APPROVAL_SUCCESS>;

export const SELECTIONLIST_SEND_FOR_APPROVAL_ERROR = 'SELECTIONLIST_SEND_FOR_APPROVAL_ERROR';
export type SelectionlistSendForApprovalErrorAction = {
    type: typeof SELECTIONLIST_SEND_FOR_APPROVAL_ERROR;
    payload: string;
};

export const SELECTIONLIST_FETCH_REQUIRED_SPOC = 'SELECTIONLIST_FETCH_REQUIRED_SPOC';
export type SelectionlistFetchRequiredSpocAction = Action<typeof SELECTIONLIST_FETCH_REQUIRED_SPOC>;

export const SELECTIONLIST_FETCH_REQUIRED_SPOC_SUCCESS = 'SELECTIONLIST_FETCH_REQUIRED_SPOC_SUCCESS';
export type SelectionlistFetchRequiredSpocSuccessAction = {
    type: typeof SELECTIONLIST_FETCH_REQUIRED_SPOC_SUCCESS;
    payload: SpocContextChangeResponse;
};

export const SELECTIONLIST_CLEAR_REQUIRED_SPOC = 'SELECTIONLIST_CLEAR_REQUIRED_SPOC';
export type SelectionlistClearRequiredSpocAction = Action<typeof SELECTIONLIST_CLEAR_REQUIRED_SPOC>;

export type OrderListAction =
    | ChangeActiveSelectionlistAction
    | SelectionlistSummarySuccessAction
    | SelectionlistSummaryFailureAction
    | SelectionlistsUpdateNameAction
    | SelectionlistGroupedRequestAction
    | SelectionlistGroupedSuccessAction
    | SelectionlistGroupedFailureAction
    | SelectionlistGroupedChangeRequestAction
    | SelectionlistGroupedMoveRequestAction
    | SelectionlistGroupedChangeSuccessAction
    | SelectionlistGroupedChangeFailureAction
    | SelectionlistGroupedMoveSuccessAction
    | SelectionlistGroupedMoveFailureAction
    | SelectionlistDeleteConfirmationAction
    | SelectionlistEditRequestAction
    | SelectionlistEditAbortEmptyTextAction
    | SelectionlistEditConfirmationAction
    | SelectionlistVisibilityAction
    | SelectionlistSendForApprovalErrorAction
    | SelectionlistSendForApprovalRequestAction
    | SelectionlistSendForApprovalSuccessAction
    | SelectionlistFetchRequiredSpocAction
    | SelectionlistFetchRequiredSpocSuccessAction
    | SelectionlistClearRequiredSpocAction
    | ChangeSharedStateAction;

export type OrderListsAction =
    | CreateSelectionlistAction
    | DeleteSelectionlistAction
    | SetActiveListAction
    | SelectionlistsRequestAction
    | SelectionlistsSuccessAction
    | SelectionlistsFailureAction
    | SelectionlistsUpdateNameAction
    | SelectionlistSummarySuccessAction
    | AddToListAction
    | SelectionlistToggleSelectionbarAction;
